(() => {
  if (window.__amouuBlogProductTrackingInstalled) return;
  window.__amouuBlogProductTrackingInstalled = true;

  const articleContentSelector = ".hdt-main-article .hdt-article-content .hdt-rte";
  const productLinkSelector = `${articleContentSelector} a[href*="/products/"]`;

  document.addEventListener(
    "click",
    (clickEvent) => {
      const link = clickEvent.target.closest(productLinkSelector);
      if (!link) return;

      const productUrl = new URL(link.href, window.location.origin);
      const productHandle = productUrl.pathname.split("/products/")[1]?.split("/")[0] || "";
      const productLinks = Array.from(document.querySelectorAll(productLinkSelector));
      const articleTitle = document.querySelector(".hdt-main-article h1")?.textContent?.trim() || document.title;
      const articleHandle = window.location.pathname.split("/blogs/")[1]?.split("/").slice(1).join("/") || "";

      const eventData = {
        article_handle: articleHandle,
        article_title: articleTitle,
        product_handle: productHandle,
        product_path: productUrl.pathname,
        link_text: link.textContent.trim().replace(/\s+/g, " ").slice(0, 200),
        link_position: Math.max(productLinks.indexOf(link) + 1, 1),
      };

      if (typeof window.Shopify?.analytics?.publish === "function") {
        try {
          const publishResult = window.Shopify.analytics.publish("amouu:blog_product_click", eventData);
          if (publishResult && typeof publishResult.catch === "function") {
            publishResult.catch(() => {});
          }
        } catch (_) {
          // Keep navigation working if Shopify's analytics bridge is unavailable.
        }
      }
    },
    { capture: true }
  );
})();
